import { deepEqual, RxCollection, RxCollectionCreator, RxJsonSchema } from "rxdb";

export const collectionName = "chatmessages";
export type ChatMessageType = {
    id: string;
    from: {
        name: string;
    };
    message: string;
    lastChange: number;
}
export const collectionCreators = {
    [collectionName]: {
        schema: {
            version: 0,
            primaryKey: "id",
            type: "object",
            properties: {
                id: { type: "string", maxLength: 200 },
                from: {
                    type: "object",
                    properties: {
                        name: { type: "string" },
                    },
                    required: ["name"],
                },
                message: { type: "string" },
                lastChange: { type: "number", minimum: 0, maximum: 2701307494132, multipleOf: 1 },
            },
            required: ["id", "message", "from"],
        } as RxJsonSchema<ChatMessageType>,
        conflictHandler: {
            isEqual(a, b) {
                return deepEqual(
                    a,
                    b
                );
            },
            resolve(input) {
                const ret = input.newDocumentState.lastChange > input.realMasterState.lastChange
                    ? input.newDocumentState
                    : input.realMasterState;
                return Promise.resolve(ret);
            }
        },
    } as RxCollectionCreator<ChatMessageType>,
};
export const postHandler = (db: {[collectionName]: RxCollection<ChatMessageType>}) => {
    db[collectionName].preSave(d => {
        d.lastChange = Date.now();
        return d;
    }, true);
};